<template>
  <div class="bc" style="overflow: hidden">
    <div class="header">
      <!-- <img class="bgImg" src="/static/newHomeImg/home_img_banner.png" alt="" /> -->
      <div class="h1">
        <img class="hImg" src="/static/newHomeImg/1.png" alt="" style="display: inline-block;">
      </div>
      <div class="titleNav">
        <div class="title">一站式综合解决方案</div>
        <div class="navBox">
          <div class="tag" v-for="(item, index) in btnData" @click="routerPush(index)">
            <img class="tagImg" :src="item.src" alt="" />
            <div class="tagText1">{{item.title}}</div>
            <div class="tagText2">
              {{item.text}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <select-nav></select-nav>
    <div class="img2">
      <div class="title">资质荣誉</div>
      <div class="text">公司成立以来，已取得专利10项，软件著作权8项</div>
    </div>
    <caseView></caseView>
    <agent></agent>
    <footerBox></footerBox>
  </div>
</template>
<script>
  import caseView from "./caseView.vue";
  import agent from "./agent.vue";
  import selectNav from "./selectNav.vue";
  import footerBox from "./footer.vue";
  export default {
    components: {
      caseView,
      agent,
      selectNav,
      footerBox
    },
    created: function() {

      document.documentElement.style.fontSize = 16 + "px"
      //			this.$emit('header', false);
      this.$emit("footer", false);
      // if(this._isMobile()) {
      // 	this.pc = false
      // 	this.$emit('header', false);
      // 	this.$emit('footer', false);
      // 	this.$emit('footer1',false);
      // 	this.$emit('footer2', true);
      // } else {
      // 	this.pc = true
      // 	window.onbeforeunload = function() {
      // 		document.documentElement.scrollTop = 0; //ie下
      // 		document.body.scrollTop = 0; //非ie
      // 	}
      // }
    },
    methods: {
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      },
      routerPush(index) {
        // window.location.href = this.btnData[index].link;
        this.$router.push(this.btnData[index].link)
      }
    },
    mounted() {
      window.onresize = function() { //监听屏幕的改变
        document.documentElement.style.fontSize = 16 + "px"
      }

    },
    data() {
      return {

        btnData: [{
            title: "智慧农贸",
            text: "安宣智慧农贸：线上线下一体化，形象效益双提升",
            src: "/static/newHomeImg/solution_img_smartfarmers_1.png",
            link: "/publicity"
          },

          {
            title: "数字农业",
            text: "农产品追溯：农田到餐桌，安全可追溯",
            src: "/static/newHomeImg/solution_img_agriculture_2.png",
            link: "/retrospect"
          },
          {
            title: "产品追溯",
            text: "来源可追溯，生产可记录，去向可查证，责任可追究",
            src: "/static/newHomeImg/solution_img_producttraceability_3.png",
            link: "/zycpzs"
          },
          {
            title: "数字菜场",
            text: "饿了么数字菜场，助力中国",
            src: "/static/newHomeImg/solution_img_digitalmarket_4.png",
            link: "/elmmarket"
          },
          {
            title: "阳光餐饮",
            text: "提供智慧监管+公众服务的一体化食品安全解决方案，助力社会食安共治、共建、共享",
            src: "/static/newHomeImg/solution_img_sunshinecatering_5.png",
            link: "/cyqy"
          },
          {
            title: "阳光食堂",
            text: "采用移动互联网、云计算、视频监控等技术。建设校园阳光食堂，食品安全看得见",
            src: "/static/newHomeImg/solution_img_sunshinecanteen_6.png",
            link: "/ygst"
          }
        ]
      };
    }
  };
</script>

<style scoped>
  /* @import "../../font/FZCQJW/FZCQJW.css"; */
  .bc {
    background-color: #fafafa;
  }


  .header {
    min-width: 1200px;
    /* padding-top: 15.9375rem; */
    padding-top: 50px;
    background-image: url("/static/newHomeImg/home_img_banner.png");
    background-repeat: no-repeat;
    background-size: 100% 400px;
    /* background-size: 100%; */
  }

  /* @font-face {
      font-family: "headerTitle";
      src: url("../../font/FZCQJW/FZCQJW.ttf");
    } */
  .h1 {
    width: 100%;
    text-align: center;
    height: 67px;
    margin: 104px auto 104px;
    /*margin: 104px auto 104px;
  width: 1003px;

  font-size: 72px;
  font-family:"FZCQJW";
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;*/
  }

  .bgImg {
    width: 100%;
    font-size: 16px;
  }

  .titleNav {
    /* width: 100rem; */

    width: 1200px;
    height: 800px;
    height: 645px;
    background-color: #fff;
    margin: 0 auto 96px;
    z-index: 2;
    border-radius: 10px;
  }

  .titleNav .title {
    margin: 0 auto 10px;
    line-height: 36px;
    text-align: center;
    font-size: 30px;
    font-weight: Bold;
    width: 210px;
    height: 36px;
    background: #dcecff;
    border-radius: 0px 0px 18px 18px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0075ff;

    text-align: center;
  }

  .titleNav .navBox {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: space-between;
    /* justify-content: ; */
  }

  .titleNav .navBox .tag {
    width: 400px;
    height: 350px;
    height: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    /* background-color: red; */
  }

  .titleNav .navBox .tag .tagImg {
    width: 85px;
    height: 85px;
    margin: 50px 0 30px 0;
    background: #ffffff;
  }

  .titleNav .navBox .tag .tagText1 {
    font-weight: bold;
    margin-bottom: 14px;
    text-align: center;
    width: 80px;
    height: 20px;
    font-size: 20px;
    font-family: Microsoft YaHei;
  }

  .titleNav .navBox .tag .tagText2 {
    font-size: 24px;
    line-height: 22px;
    margin-bottom: 16px;
    text-align: center;
    width: 225px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 28px;
  }

  .titleNav .navBox .tag:hover {
    color: #0071f6;
    box-shadow: 0px 3px 24px 0px rgba(168, 187, 196, 0.3);
  }

  .selectNav {
    background-image: url("/static/newHomeImg/hardware/products_img_bg.png");
    background-repeat: no-repeat;
    background-size: 100% 269px;
    min-width: 1200px;
    padding-top: 65px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    background-color: #fff;
  }

  .selectNav .navTitle {
    line-height: 28px;
    height: 31px;
    font-size: 30px;
    text-align: center;
    margin-bottom: 72px;
  }

  .boxItem {
    width: 1230px;
    display: flex;
    margin: 0 auto;
  }

  .boxItem .leftItem {
    background-color: red;
    width: 392px;
    height: 684px;
    margin-bottom: 45px;
    background-color: #2589ff;
  }

  .boxItem .leftItem .newTitle {
    width: 240px;
    height: 31px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
    margin: 39px 0 31px 29px;
  }

  .flex {
    display: flex;
  }

  .boxItem .leftItem ul li {
    height: 80px;
    display: flex;
    justify-content: space-between;
  }

  .boxItem .leftItem .select {
    color: #fff !important;
  }

  .boxItem .leftItem .text1 {
    width: 40px;
    height: 30px;
    font-size: 40px;
    font-family: Geometr415 Blk BT;
    font-weight: 900;
    color: #5ca7ff;
    line-height: 28px;
    margin: 26px 34px 26px 31px;
  }

  .tag:nth-of-type(1) {
    border-top: 1px solid #f3f3f3;
    border-right: 1px solid #f3f3f3;
    border-bottom: 1px solid #f3f3f3;
  }

  .tag:nth-of-type(2) {
    border-top: 1px solid #f3f3f3;
    border-right: 1px solid #f3f3f3;
    border-bottom: 1px solid #f3f3f3;
  }

  .tag:nth-of-type(3) {
    border-top: 1px solid #f3f3f3;
    border-bottom: 1px solid #f3f3f3;
  }

  .tag:nth-of-type(4) {
    border-right: 1px solid #f3f3f3;
  }

  .tag:nth-of-type(5) {
    border-right: 1px solid #f3f3f3;
  }

  .boxItem .leftItem .text2 {
    height: 24px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #84bdff;
    line-height: 28px;
    margin: 26px 0;
  }

  .boxItem .leftItem .selectImg {
    width: 32px;
    height: 32px;
    margin-right: 30px;
    margin-top: 24px;
  }

  .boxItem .leftItem .selectImg1 {
    background-color: #fff;
    border-radius: 50%;
  }

  .select {
    background: #50a0ff;
    color: #ffffff;
  }

  .img2 {
    width: 100%;
    min-width: 1200px;
    height: 654px;
    background-size: 100% 100%;
    background-image: url("/static/newHomeImg/img_qualificationandhonor.png");
  }

  .img2 .title {
    margin: 0 auto 23px;
    padding-top: 59px;
    width: 120px;
    height: 31px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 28px;
  }

  .img2 .text {
    margin: 0 auto;
    width: 392px;
    height: 19px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
  }

  .rightHeader {
    display: flex;
  }

  .secondTitle {
    width: 230px;
    text-align: center;
    line-height: 100px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #c2ddff;
  }

  .selectSecond {
    color: #fff;

    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }

  .selectSecond::after {}
</style>



// WEBPACK FOOTER //
// src/page/newHomePage/newHome.vue